<template>
  <main class="loading-page">
    <div
      class="loading-content"
      role="status"
      aria-live="polite"
    >
      <img
        class="loading-heart"
        src="../images/ban6/love.png"
        alt=""
      >
      <p class="loading-text">
        {{ $t('pro2.loading') }}
      </p>
    </div>
  </main>
</template>

<script>
export default {
  name: 'LoadingPage',
  data() {
    return {
      redirectTimer: null,
    };
  },
  created() {
    this.$parent.footer('item', true);
  },
  mounted() {
    this.redirectTimer = window.setTimeout(() => {
      this.redirectTimer = null;
      this.$router.replace('/buy/1');
    }, 6000);
  },
  beforeDestroy() {
    if (this.redirectTimer !== null) {
      window.clearTimeout(this.redirectTimer);
      this.redirectTimer = null;
    }
  },
};
</script>

<style lang="less" scoped>
.loading-page {
  position: relative;
  min-height: calc(100vh - 64px - env(safe-area-inset-bottom));
  overflow: hidden;
  isolation: isolate;
  background-color: #111;
}

.loading-page::before,
.loading-page::after {
  position: absolute;
  inset: 0;
  content: '';
  pointer-events: none;
}

.loading-page::before {
  z-index: 0;
  inset: -10%;
  background: url('../images/ban6/loading.jpg') center / cover no-repeat;
  animation: background-pan 12s ease-in-out infinite alternate;
}

.loading-page::after {
  z-index: 1;
  background: linear-gradient(180deg, rgba(7, 11, 14, 0.2) 0%, rgba(12, 19, 24, 0.28) 52%, rgba(5, 8, 10, 0.38) 100%);
}

.loading-content {
  position: relative;
  z-index: 2;
  min-height: inherit;
  padding: 0 20px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
  color: #fff;
  text-align: center;
}

.loading-heart {
  width: 128px;
  max-width: 42vw;
  height: auto;
  filter: drop-shadow(0 0 22px rgba(255, 100, 160, 0.42));
  animation: heart-pulse 2s ease-in-out infinite;
}

.loading-text {
  margin: 21px 0 0;
  color: #fff;
  font-size: 18px;
  line-height: 26px;
  text-shadow: 0 1px 3px rgba(0, 0, 0, 0.45);
}

@keyframes heart-pulse {
  0%,
  100% {
    transform: translateY(0) scale(1);
  }

  50% {
    transform: translateY(-9px) scale(1.09);
  }
}

@keyframes background-pan {
  from {
    transform: translate(7%, 7%);
  }

  to {
    transform: translate(-7%, -7%);
  }
}

@media (prefers-reduced-motion: reduce) {
  .loading-page::before,
  .loading-heart {
    animation: none;
  }
}
</style>
